const trendingImages: Record<string, string> = {
  'trend-1': 'https://readdy.ai/api/search-image?query=Premium%20oversized%20grey%20marl%20hoodie%20draped%20on%20minimal%20concrete%20block%2C%20natural%20window%20light%20from%20left%20side%2C%20contemporary%20streetwear%20product%20photography%2C%20soft%20shadows%20and%20textured%20fabric%20detail%2C%20urban%20minimalist%20aesthetic&width=600&height=600&seq=trend1-v2&orientation=squarish',
  'trend-2': 'https://readdy.ai/api/search-image?query=Pair%20of%20classic%20retro%20Jordan%20sneakers%20on%20basketball%20court%20hardwood%20floor%2C%20dramatic%20arena%20spotlight%20from%20above%2C%20sports%20editorial%20product%20photography%2C%20iconic%20silhouette%20with%20bold%20red%20and%20black%20colorway%2C%20athletic%20heritage%20vibe&width=600&height=600&seq=trend2-v2&orientation=squarish',
  'trend-3': 'https://readdy.ai/api/search-image?query=Three%20designer%20graphic%20t-shirts%20displayed%20on%20minimal%20wooden%20hangers%20against%20sage%20green%20wall%2C%20soft%20even%20studio%20lighting%2C%20boutique%20fashion%20product%20photography%2C%20artistic%20print%20designs%20visible%2C%20clean%20contemporary%20retail%20aesthetic&width=600&height=600&seq=trend3-v2&orientation=squarish',
  'trend-4': 'https://readdy.ai/api/search-image?query=Distressed%20vintage%20denim%20jacket%20on%20rustic%20reclaimed%20wood%20background%2C%20warm%20golden%20sunset%20light%20through%20window%2C%20americana%20editorial%20fashion%20photography%2C%20worn%20texture%20and%20fading%20detail%2C%20nostalgic%20heritage%20workwear%20style&width=600&height=600&seq=trend4-v2&orientation=squarish',
};

export default function TrendingShowcase() {
  const trendingItems = [
    { name: 'Nike Tech Hoodie', category: 'Streetwear', seq: 'trend-1' },
    { name: 'Jordan 4 Retro', category: 'Sneakers', seq: 'trend-2' },
    { name: 'Designer Tee Pack', category: 'T-Shirts', seq: 'trend-3' },
    { name: 'Vintage Jacket', category: 'Outerwear', seq: 'trend-4' },
  ];

  return (
    <section className="py-16 md:py-20 px-4 md:px-6 bg-foreground-950">
      <div className="max-w-7xl mx-auto">
        <div className="mb-10">
          <span className="inline-block px-4 py-1.5 rounded-full border border-white/20 text-xs font-semibold text-white/70 uppercase tracking-wider mb-4 bg-white/5">
            Trending Now
          </span>
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-white">
            Latest Sheet Drops
          </h2>
          <p className="mt-3 text-white/60 text-base max-w-xl">
            Fresh PandabuySpreadsheet additions updated weekly — stay ahead of the trends with our latest curated finds.
          </p>
        </div>

        <div className="flex gap-5 overflow-x-auto pb-4 -mx-4 px-4 md:px-0 md:mx-0 md:grid md:grid-cols-4 md:overflow-visible">
          {trendingItems.map((item) => (
            <div key={item.seq} className="flex-shrink-0 w-64 md:w-auto">
              <div className="rounded-xl overflow-hidden bg-background-100" style={{ aspectRatio: '1/1' }}>
                <img
                  src={trendingImages[item.seq]}
                  alt={`${item.name} — PandabuySpreadsheet trending`}
                  className="w-full h-full object-cover object-top"
                  title={`PandabuySpreadsheet ${item.name}`}
                />
              </div>
              <div className="mt-3">
                <h3 className="text-white text-sm font-semibold">{item.name}</h3>
                <p className="text-white/50 text-xs mt-1">{item.category}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}